/* import __COLOCATED_TEMPLATE__ from './regulatory-address-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();